// extracted by extract-css-chunks-webpack-plugin
module.exports = {"notificationsOptInBanner":"notificationsOptInBanner_B94Gc","show":"show_rxHiO"};